module.exports = __webpack_public_path__ + "static/media/jerikan.422a181a.jpg";